import { useThemesStore } from '../../store';
import { ImageConfig } from '../../store/types'; // Assuming ImageConfig is defined in the types

const useGetThemeImages = (): ImageConfig => {
  const { imagesSet = {} } = useThemesStore();
  return imagesSet;
};

export default useGetThemeImages;
